import React, { useContext } from 'react';
import { CountryContext } from './CountryContext';
import { CountryErrorFallback } from './CountryProvider';
import type { CountryContextValue } from './CountryContext';

export const useCountries = (): CountryContextValue => {
  const context = useContext(CountryContext);

  if (context === undefined) {
    throw new Error('useCountries must be used within a CountryProvider');
  }

  return context;
};

export const useCountryErrorUI = () => {
  const { isUsingFallback, retry } = useCountries();

  return {
    shouldShowError: isUsingFallback,
    ErrorComponent: () =>
      React.createElement(CountryErrorFallback, {
        onRetry: retry,
        isUsingFallback,
      }),
    retry,
  };
};
